import { render, staticRenderFns } from "./M4.vue?vue&type=template&id=8bf33b3e&scoped=true"
import script from "./M4.vue?vue&type=script&lang=js"
export * from "./M4.vue?vue&type=script&lang=js"
import style0 from "./M4.vue?vue&type=style&index=0&id=8bf33b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf33b3e",
  null
  
)

export default component.exports